"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "feedback",
  fields: {
    rating: {
      id: "complaint-rating",
      jsonPath: "services[0].rating",
      required: true
    },
    selectedSevice: {
      id: "feedback-service",
      jsonPath: "services[0].feedback"
    },
    comments: (0, _defineProperty3.default)({
      id: "feedback-comments",
      jsonPath: "actionInfo[0].comments",
      hintText: "CS_COMMON_COMMENTS_PLACEHOLDER",
      pattern: /^[^\$\"'<>\?~`!&@#$%^+={}\[\]*]{1,500}$/i
    }, "hintText", "CS_COMMON_COMMENTS_PLACEHOLDER2"),
    action: {
      id: "action",
      jsonPath: "actionInfo[0].action",
      value: "close"
    }
  },
  submit: {
    type: "submit",
    label: "CS_COMMON_SUBMIT",
    id: "feedback-submit-action"
  },
  action: "_update",
  redirectionRoute: "/feedback-acknowledgement",
  saveUrl: "/rainmaker-pgr/v1/requests/_update"
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/pgr-citizen/feedback.js
// module id = 2084
// module chunks = 1143